import { useState, useMemo, useRef, useCallback } from 'react'
import { TreeSelect, Spin, notification } from 'antd'
import debounce from 'lodash/debounce'
import { getHtmlParentElement, handleErrorCatchLog, renderTranslation } from '../../../Helpers/GenericHelpers'
import { useAppDispatch, useAppSelector } from '../../../hooks'
import { searchTags, ITag, IEditTag } from 'Services/Kiosk/TagsService'
import { TranslationKeys } from 'Constants/TranslationKeys'

interface MultiSelectTagProps {
  style?: any
  handleSave: Function
  tags: IEditTag[]
}

function MultiSelectTag(props: MultiSelectTagProps) {
  const dispatch = useAppDispatch()
  const language = useAppSelector(state => state.present.language.value)

  const [options, setOptions] = useState([])
  const [tagsRetrieved, setTagsRetrieved] = useState<ITag[]>([]);
  const [fetching, setFetching] = useState(false)
  const [tagsSelected, setTagsSelected] = useState<IEditTag[]>([]);
  const fetchRef = useRef(0)

  const onSelect = (value) => {
    if(value.indexOf('|') !== -1 || value.split("_").length > 2) {
      notification.open({
        description: renderTranslation(language, TranslationKeys.tagsValidation),
        placement: 'topLeft',
        message: '',
      })
      
      return;
    }

      const tag = tagsRetrieved.find((x: ITag) => x.slug === value);

      if(tag) {
        var tagToInsert = {...tag} as IEditTag
        setTagsSelected([...tagsSelected, tagToInsert]);
      } else {
        const alreadyInsert = props.tags.filter(x => x?.id < 0);
        const insertedValues = tagsSelected.filter(x => x?.id < 0);

        const isClassifiedTag = value.indexOf("_") !== -1;

        setTagsSelected([...tagsSelected, {
          id: (alreadyInsert.length + insertedValues.length + 1) * -1,
          code: isClassifiedTag ? value.split("_")[0] : value,
          slug: value,
          isDeleted: false,
          value: isClassifiedTag ? value.split("_")[1] : ""
        } as IEditTag])
      }
  }

  const onChange = useCallback(
    data => {
      
    },
    [dispatch],
  )

  const handleClick = useCallback(
    e => {
      e.stopPropagation()
      if (e.target && e.target.className === 'ant-select-item-option-content') {
        
      }
    },
    [props],
  )

  const debounceFetcher = useMemo(() => {
    const loadOptions = text => {
      fetchRef.current += 1
      const fetchId = fetchRef.current
      if (options.length !== 0) {
        setOptions([])
        setTagsRetrieved([])
      }
      setFetching(true)
      const textLenght = 1
      if (text && text.length > textLenght) {
        searchTags(text)
          .then((data: any) => {
            if (fetchId !== fetchRef.current) {
              return
            }

            let result = data.map((tag: ITag) => {
              return { value: tag?.slug, label: tag?.slug }
            })
            if(!result.find((x: any) => x?.value === text)) {
              result.push({
                value: text,
                label: text
              })
            }

            setOptions(result)
            setTagsRetrieved(data);
            setFetching(false)
          })
          .catch(err => {
            handleErrorCatchLog(err, 'Error on tag search getAutocomplete')
          })
      } else {
        setFetching(false)
      }
    }

    return debounce(loadOptions, 800)
  }, [options.length])

  return (
    <TreeSelect
      style={props.style}
      onSearch={debounceFetcher}
      onSelect={onSelect}
      onChange={onChange}
      treeData={options}
      treeCheckable={true}
      treeCheckStrictly={true}
      value={tagsSelected.map(tag => {
        return { value: tag.slug, label: tag.slug }
      })}
      className={""}
      popupClassName='exclude-modal-click'
      onClick={handleClick}
      popupMatchSelectWidth={true}
      autoFocus={true}
      tabIndex={0}
      notFoundContent={fetching ? <Spin size='small' /> : null}
      getPopupContainer={getHtmlParentElement}
      aria-multiselectable={true}
      onBlur={(e) => {
        props.handleSave(tagsSelected);
        setTagsSelected([]);
      }}
    />
  )
}

export default MultiSelectTag
